import * as _0 from "./amino";
const amino = {
  ..._0
};
export {
  amino
};
